parsedMessageArr